document.addEventListener("DOMContentLoaded", function () {

    const widget = document.getElementById("FloatingVideoWidget");
    const floatingVideo = document.getElementById("floatingVideo");

    const modal = document.getElementById("FloatingVideoModal");
    const popupVideo = document.getElementById("popupVideo");

    if (!widget || !floatingVideo || !modal || !popupVideo) return;

    const closeWidget = widget.querySelector(".floating-video-close");
    const closePopup = modal.querySelector(".popup-close");
    const overlay = modal.querySelector(".floating-video-overlay");

    // -----------------------------
    // Start Floating Video
    // -----------------------------

    function startFloatingVideo() {

        floatingVideo.muted = true;
        floatingVideo.defaultMuted = true;
        floatingVideo.playsInline = true;
        floatingVideo.loop = true;

        const playPromise = floatingVideo.play();

        if (playPromise !== undefined) {
            playPromise.catch(function (err) {
                console.log("Autoplay prevented:", err);
            });
        }

    }

    window.addEventListener("load", function () {

        setTimeout(function () {

            startFloatingVideo();

        }, 500);

    });

    // -----------------------------
    // Open Popup
    // -----------------------------

    function openPopup() {

        floatingVideo.pause();

        popupVideo.currentTime = floatingVideo.currentTime;

        popupVideo.muted = false;
        popupVideo.controls = true;

        modal.classList.add("active");
        modal.setAttribute("aria-hidden", "false");

        document.body.classList.add("video-popup-open");

        popupVideo.play().catch(function (e) {
            console.log(e);
        });

    }

    // -----------------------------
    // Close Popup
    // -----------------------------

    function closeVideoPopup() {

        popupVideo.pause();

        floatingVideo.currentTime = popupVideo.currentTime;

        modal.classList.remove("active");
        modal.setAttribute("aria-hidden", "true");

        document.body.classList.remove("video-popup-open");

        startFloatingVideo();

    }

    // -----------------------------
    // Open
    // -----------------------------

    widget.addEventListener("click", function (e) {

        if (
            e.target.classList.contains("floating-video-close")
        ) return;

        openPopup();

    });

    // -----------------------------
    // Close
    // -----------------------------

    closePopup.addEventListener("click", function () {

        closeVideoPopup();

    });

    overlay.addEventListener("click", function () {

        closeVideoPopup();

    });

    // -----------------------------
    // ESC Key
    // -----------------------------

    document.addEventListener("keydown", function (e) {

        if (
            e.key === "Escape" &&
            modal.classList.contains("active")
        ) {

            closeVideoPopup();

        }

    });

    // -----------------------------
    // Hide Widget
    // -----------------------------

    closeWidget.addEventListener("click", function (e) {

        e.stopPropagation();

        widget.classList.add("hide");

        floatingVideo.pause();

        sessionStorage.setItem("floating-video-hidden", "true");

    });

    if (sessionStorage.getItem("floating-video-hidden") === "true") {

        widget.classList.add("hide");

    }

    // -----------------------------
    // Pause on Hidden Tab
    // -----------------------------

    document.addEventListener("visibilitychange", function () {

        if (document.hidden) {

            floatingVideo.pause();

            popupVideo.pause();

        } else {

            if (modal.classList.contains("active")) {

                popupVideo.play().catch(() => {});

            } else {

                startFloatingVideo();

            }

        }

    });

});